import {Divider, Stack, Typography} from "@mui/material";
import React from "react";

const TITLE_SX = {fontSize: {xs: '18px', sm: '20px'}, lineHeight: 1.25};
const DIVIDER_SX = {display: {xs: 'none', sm: 'block'}};

export const SETTINGS_ROWS_GAP = {xs: 1.5, sm: 1};

export function SettingsSection({title, children}: {title: string, children: React.ReactNode}) {
    return (
        <Stack gap={{xs: 2.5, sm: 2}} component={'section'} aria-label={title}>
            <Typography variant={'h5'} textAlign={'start'} sx={TITLE_SX}>{title}</Typography>
            {children}
        </Stack>
    );
}

export const SettingsSectionDivider = () => <Divider sx={DIVIDER_SX}/>;
